import { Divider, Typography } from '@mui/material';
import WalletCard from './WalletCard';
import Button from 'components/Common/Button';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';

interface CardItem {
    title: string;
    description: string;
    label: string;
    icon: React.ReactElement | string;
    balance?: string | number;
}

interface BasketAndBalanceProp {
    CardItems: CardItem[];
    navigationHandler: Function;
}

function BasketAndBalance({ CardItems, navigationHandler }: BasketAndBalanceProp) {
    const navigate = useNavigate();
    return (
        <div style={{ padding: '3rem', paddingLeft: '5rem', paddingRight: '5rem' }}>
            <Typography>Baskets & Balances</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography>
                These balances do not include any pending transactions. As soon as a pending transaction is completed the total will be
                added to the available balance for that basket. To view pending transactions click into any of your baskets.
            </Typography>

            {CardItems.map((item, index) => (
                <WalletCard key={index} item={item} onClickNavigation={navigationHandler} />
            ))}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Button onClick={() => navigate(routes.sendmoney.main)} width={'45%'} sx={{ mr: 2, my: 6 }} title="Send Money " />
                <Button onClick={() => navigate(routes.sendinvoice.main)} width={'45%'} title="Send Invoice " />
            </div>
        </div>
    );
}

export default BasketAndBalance;
